const categoryFilter = document.querySelector('.category-filter');

if (categoryFilter) {
    categoryFilter.addEventListener('change', (e) => {
        const option = e.target.selectedOptions[0];
        const { link } = option.dataset;
        if (link) window.location.href = link;
    });
}

const hubFiltersForms = document.querySelectorAll('.hub-filters');

const scrollToHubFilters = () => {
    const target = document.getElementById('hub-filters');
    if (!target) return;
    const header = document.querySelector('header');
    const offset = header ? header.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'instant' });
};

hubFiltersForms.forEach((hubFiltersForm) => {
    hubFiltersForm.addEventListener('submit', () => {
        // Drop /page/N/ so a new search starts back on the first page of results.
        hubFiltersForm.setAttribute('action', `${window.location.pathname.replace(/\/page\/\d+\/?$/, '/')}#hub-filters`);
    });

    const clearFiltersBtn = hubFiltersForm.querySelector('.btn-clear-filters');
    if (clearFiltersBtn) {
        const url = new URL(clearFiltersBtn.href);
        url.hash = 'hub-filters';
        clearFiltersBtn.href = url.toString();
    }
});

if (hubFiltersForms.length) {
    if (window.location.hash === '#hub-filters') {
        window.addEventListener('load', scrollToHubFilters);
    }
}
